import React, { memo, useCallback, useContext, useMemo } from 'react';
import { useAppSelector } from '../../../redux/app';
import { TradeContext } from '../context/TradeContextProvider';
import { makeBidAskBySymbolSelector } from '../../../redux/selector';
import { validateDisable } from '@vt/vt-trading-utils'

const PlaceButton = memo(({ type }) => {
  const { instrumentInfo, handleExecute } = useContext(TradeContext);
  const payload = useAppSelector((state) => state.payload?.payload);
  const getBidAsk = useMemo(makeBidAskBySymbolSelector, []);
  const bidAsk = useAppSelector((state) => getBidAsk(state, instrumentInfo?.symbol));
  const { disable } = validateDisable(payload, useCallback)

  return (
    <div className="mt-4">
      <button
        id="entry"
        className="button-outline-entry"
        disabled={disable({
          type,
          ask: bidAsk?.ask ?? 0,
          bid: bidAsk?.bid ?? 0,
          stops_level: instrumentInfo.stops_level,
          digit: instrumentInfo.digit
        })}
        onClick={() => handleExecute(type, 201, 2)}>
        Place
      </button>
    </div>
  );
});

PlaceButton.displayName = 'PlaceButton';

const Bid = memo(() => {
  const { instrumentInfo } = useContext(TradeContext);
  const getBidAsk = useMemo(makeBidAskBySymbolSelector, []);
  const ask = useAppSelector((state) => getBidAsk(state, instrumentInfo?.symbol));
  return (
    <div className="bid">
      {ask ? ask?.ask.toFixed(instrumentInfo?.digit ?? 0) : (0).toFixed(instrumentInfo?.digit ?? 0)}
    </div>
  );
});

Bid.displayName = 'Bid';

const Ask = memo(() => {
  const { instrumentInfo } = useContext(TradeContext);
  const getBidAsk = useMemo(makeBidAskBySymbolSelector, []);
  const bid = useAppSelector((state) => getBidAsk(state, instrumentInfo?.symbol));
  return (
    <div className="ask">
      {bid ? bid?.bid.toFixed(instrumentInfo?.digit ?? 0) : (0).toFixed(instrumentInfo?.digit ?? 0)}
    </div>
  );
});

Ask.displayName = 'Ask';

const ActionButton = memo(({ typeBuy }) => {
  const { handleExecute } = useContext(TradeContext);
  const payload = useAppSelector((state) => state.payload?.payload);

  const buttonType = (type, openType) => {
    switch (type) {
      case 0:
        return (
          <div className="flex button-buy-sell">
            <button
              className="sell text-[#e5e5e5]"
              onClick={async () => {
                await handleExecute(1, 200, payload.type_fill);
              }}>
              Sell at Market
            </button>
            <div />
            <button
              className="buy text-[#e5e5e5]"
              onClick={async () => {
                await handleExecute(0, 200, payload.type_fill);
              }}>
              Buy at Market
            </button>
          </div>
        );
      case 1:
        return <PlaceButton type={typeBuy} />;
      default:
        break;
    }
  };

  return (
    <div className="mt-4" style={{ padding: '0 12px' }}>
      <div className="flex at-market">
        <Ask />
        <div />
        <Bid />
      </div>
      {buttonType(typeBuy === 0 || typeBuy === 1 ? 0 : 1, typeBuy)}
    </div>
  );
});

ActionButton.displayName = 'ActionButton';

export default ActionButton;
